import { Button } from '@zeeve-platform/button-component';
import nextbtn from '../../images/next-stepbtn.png';
import backbtn from '../../images/back-stepbtn.png';
import polkadotLogo from '../../images/Polkadot_Logo2.svg';

interface Foot {
  first: boolean;
  prev: () => void;
  last: boolean;
  showNext: boolean;
  nextPage: () => void;
  submit: () => void;
}
const NextPrevFooter = ({
  first,
  prev,
  nextPage,
  showNext,
  last,
  submit,
}: Foot) => (
  <div>
    <hr className="mt-5 mb-5" />
    <div className="col-11 mb-5 mx-auto">
      <div className="row">
        <div className="col-xl-8 col-lg-8 col-md-2">
          <img
            src={polkadotLogo}
            alt="polkadot-logo"
            style={{ width: '100px' }}
          />
        </div>
        <div className="col-xl-4 py-1 col-lg-4 col-md-12 text-end">
          <div className="d-flex justify-content-end">
            {!first && (
              <Button
                type="button"
                id="prevBtn"
                className="btn-outline-secondary mx-2"
                onClick={() => prev()}
              >
                <img src={backbtn} alt="" />
                <span>Back</span>
              </Button>
            )}
            {!last && (
              <Button
              type="button"
              className="btn btn-success"
              id="nextBtn"
              disabled={showNext}
              onClick={() => nextPage()}
              >
                <img src={nextbtn} alt="" />
                <span>Next Step</span>
              </Button>
            )}
            {last && (
              <Button
                type="button"
                className="btn btn-success"
                id="nextBtn"
                disabled={showNext}
                onClick={() => submit()}
              >
                <span>Create</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default NextPrevFooter;
